"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SDKProvider", {
  enumerable: true,
  get: function get() {
    return _SDKProvider["default"];
  }
});
Object.defineProperty(exports, "uuidv4", {
  enumerable: true,
  get: function get() {
    return _uuid.uuidv4;
  }
});

var _EventManager = _interopRequireDefault(require("./Utils/EventManager"));

var _EventNames = _interopRequireDefault(require("./Common/EventNames"));

var _SDKProvider = _interopRequireDefault(require("./SDKProvider"));

var _uuid = require("./Utils/uuid");

// Entry point
(function () {
  // Declares window object for NodeJS environment
  if (global.window === undefined) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    global.window = global;
  }

  if (!window) {
    throw new Error("window object not found");
  } // Check existence of global objects to avoid overwrite/clashing


  if (!("Microsoft" in window)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.Microsoft = {};
  }

  if (!("CRM" in window.Microsoft)) {
    window.Microsoft.CRM = {};
  }

  if (!("Omnichannel" in window.Microsoft.CRM)) {
    window.Microsoft.CRM.Omnichannel = {};
  }

  if (!("SDK" in window.Microsoft.CRM.Omnichannel)) {
    window.Microsoft.CRM.Omnichannel.SDK = {
      SDKProvider: _SDKProvider["default"],
      Util: {
        uuidv4: _uuid.uuidv4
      }
    };
  }

  window.document && _EventManager["default"].raiseCustomEvent(_EventNames["default"].OCSDKLOAD);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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